<div class="modal-header d-flex justify-content-between">
    <h4 class="modal-title pull-left">{{this.message.lookup.description}}</h4>
    <button type="button" class="btn btn-default pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <i class="pi pi-times"></i>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col">
            <div class="row">
                    <div *ngIf="this.message.lookup.type==='LR' || this.message.lookup.type==='R'" class="col-md-auto mb-20">
                        <app-mode-toggle (modeChanged)="modeChanged($event)"
                            [disabled]="this.message.lookup.disableToggle || this.message.lookup.type==='R'"></app-mode-toggle>
                    </div>
                    <div class="col-md-auto mb-20" style="border-left: 1px solid var(--bs-border-color)" *ngIf="this.message.isCondition">
                        <button class="btn btn-light" (click)="onButtonAction('selectAll')">&#x2611;</button>
                    </div>
            </div>
            <div *ngIf="isTabActive('local')">
                <app-static-finder [lookup]="this.message.lookup" [local]="isTabActive('local')" 
                                    (selectedElement)="select($event)"></app-static-finder>
            </div>

            <div *ngIf="isTabActive('remote')">
                <app-lookup-finder [lookup]="this.message.lookup" (selectedElement)="select($event)" [selectedValue]="this.message.selectedValue" [isCondition]="this.message.isCondition" #app_lookup_finder></app-lookup-finder>
            </div>

        </div>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="onButtonAction('loadSelected')"  *ngIf="this.message.isCondition">Select</button>
    <button type="button" class="btn btn-light" *ngIf="this.message.selectedValue&&this.message.selectedValue.length>0" (click)="select({selectedCode:'blank',selectedName:'blank'})">Clear selected value</button>
    <button type="button" class="btn btn-light" (click)="bsModalRef.hide()">Close</button>
</div>